import React from 'react'
import HeaderHome from '../home/components/HeaderHome';
import ContentHome from '../home/components/ContentHome'


export default function Home() {
  return (
    <>
      <HeaderHome />
      <ContentHome />
    </>
  )
}